<div class="modal-header" appCustomAutofocus>
    <h3>Emergency Contacts</h3>
</div>
<div class="modal-body">
    <div>
        <table class="table" *ngIf="contactList?.length > 0">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Relationship</th>
                    <th>Home Phone</th>
                    <th>Cell Phone</th>
                    <th>Work Phone</th>
                    <th>Note</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let row of contactList">
                    <tr>
                        <td>{{row.ContactName}}</td>
                        <td>{{row.Relationship}}</td>
                        <td>{{row.HomePhone}}</td>
                        <td>{{row.CellPhone}}</td>
                        <td>{{row.WorkPhone}}</td>
                        <td>{{row.Note}}</td>
                        <td><button type="button" class="btn btn-primary" (click)="expendRow(row)">View</button></td>
                    </tr>
                    <tr *ngIf="row.Expended">
                        <td colspan="6">
                            <div class="card border">
                                <div class="card-body">
                                    <form #rowContact="ngForm">
                                        <div class="row" style="margin-bottom:10px;overflow-wrap: normal;">
                                            <div class="col-lg-3">
                                                <strong>Contact Name</strong>
                                                <p>{{row.ContactName}}</p>
                                            </div>
                                            <div class="col-lg-2">
                                                <strong>Relationship</strong>
                                                <p>
                                                    {{row.Relationship}}
                                                </p>
                                            </div>
                                            <div class="col-lg-2">
                                                <strong>Home Phone</strong>
                                                <p>{{row.HomePhone}}</p>
                                            </div>
                                            <div class="col-lg-2">
                                                <strong>Cell Phone</strong>
                                                <p>{{row.CellPhone}}</p>
                                            </div>
                                            <div class="col-lg-2">
                                                <strong>Work Phone</strong>
                                                <p>{{row.WorkPhone}}</p>
                                            </div>
                                        </div>
                                        <div class="row" style="margin-bottom:10px;">
                                            <div class="col-lg-5">
                                                <strong>Address</strong>
                                                <p>{{row.Address}}</p>
                                            </div>
                                            <div class="col-lg-3">
                                                <strong>City</strong>
                                                <p>{{row.City}}</p>
                                            </div>
                                            <div class="col-lg-2">                                               
                                                <strong *ngIf="country != 'CAN'">State</strong>
                                                <strong *ngIf="country == 'CAN'">Province</strong>
                                                <p>{{row.State}}</p>
                                            </div>
                                            <div class="col-lg-2">
                                                <strong *ngIf="country != 'CAN'">Zip</strong>
                                                <strong *ngIf="country == 'CAN'">Postal Code</strong>
                                                <p>{{row.Zip}}</p>
                                            </div>
                                        </div>
                                        <div class="row" style="margin-bottom:10px;">
                                            <div class="col-lg-12">
                                                <strong>Note</strong>
                                                <p>{{row.Note}}</p>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-outline-dark" type="button" (click)="closeClick()">Close</button>
</div>